import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {EMPTY, Observable} from "rxjs";
import {Features, OrganiserPaymentDataService} from "@services";
import {OrganiserPaymentData} from "@model";

export const OrganiserPaymentDataResolver: ResolveFn<Observable<OrganiserPaymentData | null>> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   paymentDataService: OrganiserPaymentDataService = inject(OrganiserPaymentDataService)): Observable<OrganiserPaymentData | null> => {
    const feature : Features = route.data['feature'];
    switch (feature) {
      case Features.OrganisersEdit:
        return paymentDataService.fetchOrganiserPaymentData(+route.queryParams['organiserId'], true);
      case Features.OrganiserProfile:
        return paymentDataService.fetchOrganiserPaymentData(undefined, true);
      default:
        return EMPTY;
    }
}
